import { useEffect, useState } from 'react';
import { Card, SectionHeader, Btn } from '../../components/ui';
import { getPrivacyConfig } from '../../api/privacy';
import { useSettings } from '../../context/SettingsContext';

export default function PrivacyPolicyScreen() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const { language = 'en' } = useSettings();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await getPrivacyConfig();
        setConfig(response?.data || null);
      } catch (error) {
        console.error("Failed to load privacy config:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  return (
    <div className="fade-up space-y-5 max-w-4xl mx-auto">
      <Card>
        <SectionHeader title="Privacy Policy" subtitle="Last Updated: Recently" />
        
        {loading ? (
          <div className="animate-pulse space-y-4 py-8">
            <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-3/4"></div>
            <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/2"></div>
            <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-5/6"></div>
          </div>
        ) : (
          <div className="space-y-6 mt-6 text-sm text-ink dark:text-slate-200 leading-relaxed">
            <div dangerouslySetInnerHTML={{ __html: config?.consent_text || '<p>Our privacy policy outlines how we collect, use, and protect your personal information.</p>' }} />
            
            <h3 className="text-lg font-bold mt-8 mb-4">Grievance Officer</h3>
            {config?.grievance_officer_name ? (
              <div className="bg-slate-50 dark:bg-slate-800 p-4 rounded-xl border border-slate-200 dark:border-slate-700">
                <p className="mb-2">If you have any questions or concerns about this privacy policy, please contact our Grievance Officer:</p>
                <div className="space-y-1 mt-3">
                  <div><strong>Name:</strong> {config.grievance_officer_name}</div>
                  {config.grievance_officer_email && <div><strong>Email:</strong> <a href={`mailto:${config.grievance_officer_email}`} className="text-primary hover:underline">{config.grievance_officer_email}</a></div>}
                  {config.grievance_officer_phone && <div><strong>Phone:</strong> {config.grievance_officer_phone}</div>}
                </div>
              </div>
            ) : (
              <p>Please contact our support team for any privacy-related concerns.</p>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
